<script>
export default {
  name: "LadyCard",
  props: {
    info: {
      type: Object,
      default: function () {
        return {}
      }
    },
    showType: {
      type: String,
      default: 'info'
    }
  },
  data() {
    return {
      tagType: ['primary', 'success', 'danger', 'warning']
    }
  },
  computed: {
    tagList() {
      if (!this.info.tag) {
        return []
      }
      // 默认英文
      return this.info.tag.split('，')
    }
  },
}
</script>

<template>
  <div style="width: 100%">
    <div v-show="showType === 'info'" class="lady-info-type" @click="$router.push(`/Profile?id=${info.id}`)">
      <div class="lady-cover">
        <van-image
            :src="info.img_url"
            width="120"
            height="120"
            class="cover_img"
        >
          <template v-slot:loading>
            <van-loading type="circular"/>
          </template>
        </van-image>
        <span class="cover-tag">
        {{ $t('高端') }}
      </span>
      </div>
      <div class="lady-info">
        <div class="lady-auth">
          <div class="auth">
            <img
                :src="require('@/assets/image/vip.png')"
                width="13"
                height="13"
                alt=""
            />
            <span>{{ $t('认证') }}</span>
          </div>
          <div class="auth">
            <div class="auth-name">{{ $t('视频认证') }}</div>
          </div>
          <div class="lady-name">{{ info.xuanfei_name }}</div>
        </div>
        <div class="lady-tag">
          <van-tag :type="tagType[index%tagType.length]" size="large" v-for="(tag, index) in tagList" :key="index">
            {{ tag }}
          </van-tag>
        </div>
        <div class="lady-rate">
          <span>{{ $t('服务评分') }}：</span>
          <van-rate
              v-model="info.mark"
              :size="19"
              color="#ffd21e"
              void-icon="star"
              readonly
              void-color="#eee"
          />
        </div>
        <div class="lady-service">
          {{ $t('身高') }}: {{ info.height }} {{ $t('胸圍') }}：{{ info.chest }} {{ $t('服務城市') }}: {{ info.city }}
          {{ $t('全國空降') }}: {{ info.airborne }}
        </div>
        <div class="btn" @click.stop="$router.push(`/Profile?id=${info.id}`)">
          {{ $t('我要约她') }}
        </div>
      </div>
    </div>
    <div v-show="showType === 'cover'" class="lady-cover-type">
      <div class="cover-area">
        <van-image
            :src="info.cover"
            width="50vw"
            height="100%"
            class="cover_img"
        >
          <template v-slot:loading>
            <van-loading type="circular"/>
          </template>
        </van-image>
        <span class="cover-tag">高端</span>
        <div class="location-wrapper">
          <div class="location"></div>
          <div class="location-btn">我要预约</div>
        </div>
      </div>
      <div class="basic-info">
        <div class="tag">美少女</div>
      </div>
      <div class="like-info">
        <div class="lady-name">
          <span class="decorate"></span>
          <span class="name">名字</span>
        </div>
        <div class="like-num"></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
@movie-list-item-bottom-size: 25px;

.lady-info-type {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid #eee;
  background-color: #fff;
  padding: 20px 10px;
  width: 100%;

  .lady-cover {
    position: relative;
    overflow: hidden;

    .cover_img {
      border-radius: 20px;
      overflow: hidden;
    }

    .cover-tag {
      position: absolute;
      background-color: #ebcaaf;
      color: #8d684b;
      transform: rotate(45deg);
      width: 20vw;
      height: 20vw;
      line-height: 35vw;
      text-align: center;
      font-size: 26px;
      font-weight: bold;
      font-style: italic;
      top: -11vw;
      right: -11.5vw;
    }
  }

  .lady-info {
    flex: 1;
    .lady-auth {
      display: flex;
      justify-content: flex-start;

      .auth {
        background: linear-gradient(180deg, #e7caaf, #fff7ed);
        color: #a4826b;
        font-weight: 600;
        font-size: 3vw;
        padding: .4vw;
        margin-right: 1.333vw;
      }
    }

    .lady-name {
      width: 100px;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .lady-tag {
      margin-top: 8px;

      .van-tag--large {
        padding: 2.533vw 2.067vw;
        font-size: 2.867vw;
        border-radius: 2vw;
        margin-right: 1.333vw;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .lady-rate {
      margin-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 26px;
      color: rgb(102, 102, 102);
    }

    .lady-service {
      color: rgb(153, 153, 153);
      font-size: 24px;
      margin: 10px 0;
    }

    .btn {
      text-align: center;
      padding: 0 30px;
      color: #fff;
      background: linear-gradient(270deg, #e6c3a1, #7e5678);
      font-size: 30px;
      font-weight: 500;
      height: 65px;
      line-height: 65px;
      border-radius: 15px;
    }
  }
}

.lady-cover-type {
  .cover-area {
    .cover_img {
      border-radius: 20px;
      overflow: hidden;
    }

    .cover-tag {
      position: absolute;
      background-color: #ebcaaf;
      color: #8d684b;
      transform: rotate(45deg);
      width: 20vw;
      height: 20vw;
      line-height: 35vw;
      text-align: center;
      font-size: 26px;
      font-weight: bold;
      font-style: italic;
      top: -11vw;
      right: -12vw;
    }
  }
}
</style>